class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.toCheckoutButton = document.getElementById('checkout');
    this.couponCodeInput = document.getElementById('cart-coupon-code');
    this.cartNoteInput = document.getElementById('Cart-note')

    this.toCheckoutButton?.addEventListener('click', this.handleToCheckoutPage.bind(this))

    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.setGiftWrap();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  async handleToCheckoutPage(e) {
    e.preventDefault()

    try {
        // saving coupon
        const couponCode = this.couponCodeInput?.value 
        if (couponCode) {
            localStorage.setItem('storedDiscount', couponCode)
            const couponRes =  await fetch(`/discount/${couponCode}`)
            const text1 = await couponRes.text()
        }
        
        // saving cart note
        const cartNote = this.cartNoteInput?.value
        if (cartNote) {
            const cartNoteBody = JSON.stringify({ note: cartNote })
            const cartNoteRes = await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body: cartNoteBody }})
            const text2 = await cartNoteRes.text()
        }

    } catch(error) {
        console.error(`Error: ${error.message}`)
    }

    window.location = '/checkout'  
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cart__blocks',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        this.setGiftWrap();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  setGiftWrap() {
    const quantity = this.querySelector('[data-gift-wrapping-quantity]')?.dataset.giftWrappingQuantity;
    const itemsCount = this.querySelector('[data-gift-wrapping-items-count]')?.dataset.giftWrappingItemsCount;
    
    if (quantity != itemsCount) {
      const input = this.querySelector('[data-gift-wrapping-quantity] .quantity__input');
      input.value = itemsCount;
      this.querySelector('[data-gift-wrapping-quantity]').setAttribute('data-gift-wrapping-quantity', itemsCount);
      this.updateQuantity(input.dataset.index, input.value, document.activeElement.getAttribute('name'), input.dataset.quantityVariantId);
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

if (!customElements.get('cart-message')) {
  customElements.define('cart-message', class CartMessage extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      this.calculator();
    }

    init() {
      let rate = Shopify.currency.rate || 1;
      this.price = parseInt(this.dataset.price) * rate;
      this.total = parseFloat(this.dataset.total);
      this.symbol = this.dataset.symbol;
      this.firstText = this.dataset.firstText;
      this.secondText = this.dataset.secondText;
      this.thirdText = this.dataset.thirdText;
    }

    calculator() {
      let freeshipText,
        percent,
        freeshipClass = 'none';

      percent = ((this.total/this.price) * 100).toFixed(2);

      if(this.total == 0) {
        freeshipText = this.firstText.replace('{{ price }}', this.price);
      } else if (this.total > this.price) {
        freeshipText = this.secondText;
        freeshipClass = 'progress-free';
        percent = 100;
      } else {
        let extraPrice;

        switch (true) {
          case this.symbol.includes('{{amount}}'):
            extraPrice = this.symbol.replace('{{amount}}', this.formatting(Math.abs(this.total - this.price).toFixed(2), ","));
            break;
          case this.symbol.includes('{{amount_no_decimals}}'):
            extraPrice = this.symbol.replace('{{amount_no_decimals}}', this.formatting(Math.round(Math.abs(this.total - this.price)).toString(), ","));
            break;
          case this.symbol.includes('{{amount_with_comma_separator}}'):
            extraPrice = this.symbol.replace('{{amount_with_comma_separator}}', this.formatting(Math.abs(this.total - this.price).toFixed(2).replace (/\./g, ','), "."));
            break;
          case this.symbol.includes('{{amount_no_decimals_with_comma_separator}}'):
            extraPrice = this.symbol.replace('{{amount_no_decimals_with_comma_separator}}', this.formatting(Math.round(Math.abs(this.total - this.price)).toString(), "."));
            break;
          case this.symbol.includes('{{amount_with_apostrophe_separator}}'):
            extraPrice = this.symbol.replace('{{amount_with_apostrophe_separator}}', this.formatting(Math.abs(this.total - this.price).toFixed(2), "'"));
            break;
          case this.symbol.includes('{{amount_no_decimals_with_space_separator}}'):
            extraPrice = this.symbol.replace('{{amount_no_decimals_with_space_separator}}', Math.abs(this.total - this.price));
            break;
          case this.symbol.includes('{{amount_with_space_separator}}'):
            extraPrice = this.symbol.replace('{{amount_with_space_separator}}', Math.abs(this.total - this.price).toFixed(2).replace (/\./g, ','));
            break;
          case this.symbol.includes('{{amount_with_period_and_space_separator}}'):
            extraPrice = this.symbol.replace('{{amount_with_period_and_space_separator}}', Math.abs(this.total - this.price).toFixed(2));
            break;
        }
        
        freeshipText = this.thirdText.replace('{{ price }}', extraPrice);

        switch (true) {
          case percent <= 30:
            freeshipClass = 'progress-30';
            break;
          case percent <= 60:
            freeshipClass = 'progress-60';
            break;
          case percent <= 100:
            freeshipClass = 'progress-99';
            break;
        }
      }

      this.querySelector('.progress')?.classList.add(freeshipClass);
      this.querySelector('.message').innerText = freeshipText;
      this.querySelector('.progress__shipping')?.setAttribute('aria-label', freeshipText);
      this.querySelector('.progress__meter')?.style.setProperty('--percent', `${percent}%`);
    }

    formatting(val, format) {
      return val.replace(/\B(?=(\d{3})+(?!\d))/g, format);
    }
  });
}
